import { useEffect, useState } from 'react';

const useTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState<boolean | null>(null);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  // Return false during SSR and initial client render to prevent hydration mismatch
  return {
    isTouchDevice: isClient ? isTouchDevice : false,
    isClient,
  };
};

export default useTouchDevice;
